// JSON[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-json-@@tostringtag
require('../internals/set-to-string-tag')(require('../internals/global').JSON, 'JSON', true);



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.json.to-string-tag.js
// module id = 276
// module chunks = 1